import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import {
  ButtonV2,
  LabraToolTipV2,
  SelectV2,
  TextInputV2,
} from '@labrav/react-components'
import { useFormikContext } from 'formik'
import clsx from 'clsx'
import { useStyles as commonStyles } from '../../FlyOutStorefront.styles'
import { ButtonInCreation } from '../../../../modules/storefront/buttonCreation/reducer'
import { useStyles } from './ButtonSelect.styles'
import { buttonNames } from '../../../../utils/templateCreationConstants'
import { isEmpty, get } from 'lodash'
import { ListingProductCard } from '../../ListingCardCreationFormikWrapper/ListingDesignFormCards/ListingDesignFormCards'
import { useDispatch } from '../../../../store'
import { AnyAction } from '@reduxjs/toolkit'
import { fetchProductDetailsFromUrl } from '../../../../modules/storefront/listingCardCreation/action'
import { fetchProductDetailsFromUrlButtons } from '../../../../modules/storefront/buttonCreation/action'
export interface ButtonSelectProps {
  showHorizontalDivider?: boolean
}

export const ButtonSelect: React.FC<ButtonSelectProps> = ({
  showHorizontalDivider,
}) => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()
  const { values, errors, touched, setFieldValue, handleBlur, handleChange } =
    useFormikContext<ButtonInCreation>()
  const { buttonData } = values
  const { product } = buttonData
  const { buttonData: buttonDataErrors } = errors
  const { buttonData: buttonCardDataTouched } = touched
  const dispatch = useDispatch()

  useEffect(() => {
    if (values?.buttonData?.buttons) {
      const matchingButton = buttonNames.find(
        btn => btn.value === buttonData.selectedButton
      )
      const updatedButtons = values.buttonData.buttons.map(button => ({
        ...button,
        key: matchingButton?.value,
        title: matchingButton?.label,
      }))

      setFieldValue('buttonData.buttons', updatedButtons)
    }
  }, [buttonData.buttonCustomization, buttonData.selectedButton])

  const updateProductLink =
    (uniqueId: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const url = event.target?.value
      const updatedCards = product.map(card => {
        if (card.uniqueId === uniqueId) {
          card.url = url
        }
        return card
      })
      setFieldValue('buttonData.product', [...updatedCards])
    }
  const handleFetchDetails = (uniqueId: string, index: number) => async () => {
    await setFieldValue(`buttonData.product[${index}].isLoading`, true)
    const url =
      (product.find(card => card.uniqueId === uniqueId)?.url as string) || ''
    if (!isEmpty(url)) {
      const match = url.match(/prodview-[a-zA-Z0-9]+/)
      const productId = match ? match[0] : ''
      await dispatch(
        fetchProductDetailsFromUrlButtons(
          productId,
          index,
          values
        ) as unknown as AnyAction
      )
    }
    await setFieldValue(`buttonData.product[${index}].isLoading`, false)
  }

  return (
    <div
      className={clsx(
        classes.sectionWrapper,
        classes.sectionHeaderWrapper,
        classes.name
      )}
      data-testid="button-select-component"
    >
      <div className={classes.textContentWrapper}>
        <Typography
          // className={commonClasses.cardTextHeader}
          data-testid="button-select-text"
          className={classes.textHeading}
        >
          Buttons
        </Typography>
      </div>
      <div
        className={classes.sectionInnerWrapper}
        data-testid="button-styling-inner-component"
      >
        {/* select button */}
        <div className={classes.rowContainer}>
          <div className={classes.fieldWrapper}>
            <div>
              <SelectV2
                data-testid="button-selector"
                minWidth="119px"
                field={{
                  title: 'Select call to action',
                  placeHolder: 'Select call to action',
                  id: 'buttonData.selectedButton',
                  isRequired: false,
                  humanReadableKey: 'selectedButton',
                  isReadOnly: false,
                  isCustom: false,
                  defaultValue: buttonData.selectedButton,
                  dataType: 'string',
                  options: buttonNames,
                }}
                value={buttonData.selectedButton}
                key={'buttonData.selectedButton'}
                onChange={handleChange}
                onBlur={handleBlur}
                isError={false}
                errorText={''}
                isRequired={false}
              />
            </div>
          </div>
        </div>
        {product.map((card, index) => (
          <ListingProductCard
            isOpen={card.isOpen}
            id={card.uniqueId}
            index={index}
            url={card.url}
            onChevronClick={() => void 0}
            error={get(buttonDataErrors?.product, `${index}.url`, '')}
            touched={get(buttonCardDataTouched?.product, `${index}.url`, false)}
            onDelete={() => void 0}
            updateProductLink={updateProductLink(card.uniqueId)}
            handleBlur={handleBlur}
            handleFetchDetails={handleFetchDetails}
            shouldShowDelete={false}
            buttonLoading={get(buttonData.product, `${index}.isLoading`, false)}
            shouldShowCardHeading={false}
            shouldShowCheveron={false}
            formikKey={'buttonData'}
            shouldShowTitle={false}
            showHorizontalDivider={showHorizontalDivider}
          />
        ))}
      </div>
    </div>
  )
}
